import { render, staticRenderFns } from "./StoreProductList.vue?vue&type=template&id=4684d0b8&scoped=true"
import script from "./StoreProductList.vue?vue&type=script&lang=js"
export * from "./StoreProductList.vue?vue&type=script&lang=js"
import style0 from "./StoreProductList.vue?vue&type=style&index=0&id=4684d0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684d0b8",
  null
  
)

export default component.exports